module.exports = __webpack_public_path__ + "static/c1-98f2da3caa74cd051ef78eba6eb68c69.jpg";